import React, { Component } from 'react';

class ClientDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unitPrice:12000,
      adulte:1,
      enfant:2,
      enfantPromo:0.5
    };
     this.increment = this.increment.bind(this)
     this.decrement = this.decrement.bind(this)
  }
  increment(age){
    if (age==="adulte") {
      this.setState({
        adulte:this.state.adulte + 1
      })
    }
    else if (age==="enfant") {
      this.setState({
        enfant:this.state.enfant + 1
      })
    }

  }
  decrement(age){
    if (age==="adulte") {
      this.setState({
        adulte:this.state.adulte - 1
      })
    }
    else if (age==="enfant") {
      this.setState({
        enfant:this.state.enfant - 1
      })
    }
  }
    render() {
      const unitPrice = this.state.unitPrice
      const adulte = this.state.adulte
      const enfant = this.state.enfant
      const enfantPromo = this.state.enfantPromo
        return (
            <div className="visa-calc-det p-3">
              <div className="d-flex price__one mb-3">
                <h3 className="visa__price">{unitPrice} DZD</h3>
                <h5 className="visa__parPerson mt-1 mt-sm-2">/ 1 passager adult</h5>
              </div>
              <div className="personne__nbrs d-flex justify-content-between pb-2">
                <div className="d-flex align-items-center">
                  <h4 className="visa__persons">Adultes</h4>
                  <input
                    type="number"
                    className="inpt-calc"
                    min="1"
                    max="10"
                    placeholder="02"
                    value={adulte}
                    name=""
                    id=""
                  />
                  <div className="calc-arw">
                    <img onClick={() => this.increment("adulte")} src="/imgs/navebar/downArrow.svg" alt="price" id="arrow-parcourir-big" className="up"/>
                    <img onClick={() => this.decrement("adulte")} style={{ display: "block" }} src="/imgs/navebar/downArrow.svg" alt="price" id="arrow-parcourir-big"/>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <h4 className="visa__persons ml-md-3 ml-lg-0">Enfants</h4>
                  <input
                      type="number"
                      className="inpt-calc"
                      min="1"
                      max="10"
                      value={enfant}
                      placeholder="02"
                      name=""
                      id=""
                    />
                    <div className="calc-arw" >
                      <img
                        src="/imgs/navebar/downArrow.svg"
                        alt=""
                        id="arrow-parcourir-big"
                        className="up"
                        onClick={() => this.increment("enfant")}
                      />
                      <img
                          src="/imgs/navebar/downArrow.svg"
                        alt=""
                        id="arrow-parcourir-big"
                        onClick={() => this.decrement("enfant")}

                      />
                    </div>{" "}
                </div>
              </div>
              <div className="d-flex justify-content-end mt-2 ">
                <h5 className="visa__totTxt mr-3">Total</h5>
                <h5 className="visa__totPrice">{unitPrice*adulte + unitPrice*enfant*enfantPromo} DZD</h5>
              </div>
                         
          </div>
        );
    }
}

export default ClientDetails;
